import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseStoreService, BaseEntity } from './base-store.service';
import {apiUrl} from '../defines';
import {IdNameModel} from '../models/id.name.model';


@Injectable({
  providedIn: 'root'
})
export class BusTypeStore extends BaseStoreService<BaseEntity> {
  baseUrl = `${apiUrl}`;
  protected http = inject(HttpClient);
  protected apiUrl = `${this.baseUrl}/references/busTypes`;

  protected getEntityName(): string {
    return 'Type de bus';
  }

}
